export default {
  SERVICE_MAIN_DOMAIN: 'test3-www.benscm.com/',
  SERVICE_SECOND_DOMAIN: 'test3-supply.benscm.com/',
}
